"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MarketingPreferencesFields = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var React = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

var _index = require("../../fields/index");

var _marketingPreferencesConfig = require("./marketingPreferencesConfig");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var MarketingPreferencesDefinition = _flowRuntime["default"].tdz(function () {
  return _marketingPreferencesConfig.MarketingPreferencesDefinition;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("marketingPreferences", _flowRuntime["default"].ref(MarketingPreferencesDefinition)), _flowRuntime["default"].property("componentKey", _flowRuntime["default"].string()), _flowRuntime["default"].property("emailValue", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("phoneValue", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("postValue", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("smsValue", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("setPostValue", _flowRuntime["default"]["function"]())));

var MarketingPreferencesFields = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(MarketingPreferencesFields, _React$Component);

  var _super = (0, _createSuper2["default"])(MarketingPreferencesFields);

  function MarketingPreferencesFields() {
    (0, _classCallCheck2["default"])(this, MarketingPreferencesFields);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _super.call.apply(_super, [this].concat(args));
  }

  (0, _createClass2["default"])(MarketingPreferencesFields, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          postValue = _this$props.postValue,
          setPostValue = _this$props.setPostValue,
          componentKey = _this$props.componentKey;

      if (postValue === undefined) {
        setPostValue(componentKey);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          emailValue = _this$props2.emailValue,
          marketingPreferences = _this$props2.marketingPreferences,
          phoneValue = _this$props2.phoneValue,
          smsValue = _this$props2.smsValue;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "description"
      }, /*#__PURE__*/React.createElement("p", null, "We would love to keep in touch about all the ways you can support Anthony Nolan."), /*#__PURE__*/React.createElement("p", null, "Hear more about our lifesaving work, including news, fundraising and other ways you can support us. Let us know if you\u2019re happy for us to contact you by:")), marketingPreferences.options.email && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_index.Radio, {
        key: _marketingPreferencesConfig.email.key,
        radio: _marketingPreferencesConfig.email
      }), _marketingPreferencesConfig.email.confirmText && emailValue === false && /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("small", {
        className: "description" // eslint-disable-next-line react/no-danger
        ,
        dangerouslySetInnerHTML: {
          __html: _marketingPreferencesConfig.email.confirmText
        }
      }))), marketingPreferences.options.sms && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_index.Radio, {
        key: _marketingPreferencesConfig.sms.key,
        radio: _marketingPreferencesConfig.sms
      }), _marketingPreferencesConfig.sms.confirmText && smsValue === false && /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("small", {
        className: "description" // eslint-disable-next-line react/no-danger
        ,
        dangerouslySetInnerHTML: {
          __html: _marketingPreferencesConfig.sms.confirmText
        }
      }))), marketingPreferences.options.phone && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_index.Radio, {
        key: _marketingPreferencesConfig.phone.key,
        radio: _marketingPreferencesConfig.phone
      }), _marketingPreferencesConfig.phone.confirmText && phoneValue === false && /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("small", {
        className: "description" // eslint-disable-next-line react/no-danger
        ,
        dangerouslySetInnerHTML: {
          __html: _marketingPreferencesConfig.phone.confirmText
        }
      }))), marketingPreferences.options.post && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "From time to time, we will also send you information about our lifesaving work, including news, fundraising and other ways you can support us, by post."), /*#__PURE__*/React.createElement(_index.Checkbox, {
        key: _marketingPreferencesConfig.post.key,
        checkbox: _marketingPreferencesConfig.post
      })), /*#__PURE__*/React.createElement("div", {
        className: "post_opt_in"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("small", null, "Your details are safe with us. We promise to protect and respect your privacy. Please refer to our", ' ', /*#__PURE__*/React.createElement("a", {
        href: "https://www.anthonynolan.org/privacy-policy",
        rel: "noopener noreferrer",
        target: "_blank"
      }, "Privacy Policy"), ' ', "for more information about how we process your data. You can update your preferences at any time by visiting our website at", ' ', /*#__PURE__*/React.createElement("a", {
        href: "https://www.anthonynolan.org/update",
        rel: "noopener noreferrer",
        target: "_blank"
      }, "www.anthonynolan.org/update"))), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("small", null, "If you are on the stem cell register, we will continue to get in touch to ask you to update your details and in relation to your status as a potential donor."))));
    }
  }]);
  return MarketingPreferencesFields;
}(React.Component);

exports.MarketingPreferencesFields = MarketingPreferencesFields;
var selector = (0, _reduxForm.formValueSelector)('form');

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var componentKey = ownProps.componentKey;
  return {
    emailValue: selector(state, "".concat(componentKey, ".email")),
    phoneValue: selector(state, "".concat(componentKey, ".phone")),
    postValue: selector(state, "".concat(componentKey, ".post")),
    smsValue: selector(state, "".concat(componentKey, ".sms"))
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setPostValue: function setPostValue(componentKey) {
      return dispatch((0, _reduxForm.change)('form', "".concat(componentKey, ".post"), true));
    }
  };
}; // $FlowFixMe WEB-352


var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MarketingPreferencesFields);

exports["default"] = _default;